import { render } from "./AddOrEdit.vue?vue&type=template&id=01557fad&scoped=true"
import script from "./AddOrEdit.vue?vue&type=script&lang=js"
export * from "./AddOrEdit.vue?vue&type=script&lang=js"

import "./AddOrEdit.vue?vue&type=style&index=0&id=01557fad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01557fad"]])

export default __exports__